export default __webpack_public_path__ + "static/2-67da61f337ae30b650103c811639f946.jpg";